import { Box, Grid, Paper, Typography } from "@mui/material";
import loginBG from "../assets/images/login_background.png";
import Logo from "../components/common/Logo";
import React, { useEffect } from "react";
import FeatureTable from "../components/signup/FeatureTable";
import { setLogoutAction } from "../store/reducers/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PlanList: React.FC = () => {
  const { user } = useSelector((state: any) => state?.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.nextAction === "subscribe") {
      localStorage.removeItem("password");
    } else if (user?.length === 0) {
      navigate("/");
      localStorage.removeItem("user");
    }
  }, [user]);
  
  const handleSignout = () => {
    dispatch(
      setLogoutAction({
        userId: user?.user?.staff_id,
        isLogoutAllDevices: true,
      })
    );
    localStorage.removeItem("user");
    navigate("/");
  };
  return (
    <>
      <Grid
        container
        component="main"
        sx={{
          height: "100%",
          padding: "80px 0px",
          justifyContent: "center", // Center horizontally
          alignItems: "center", // Center vertically
          position: "relative",
          zIndex: 1, // Ensure content is above the background image
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${loginBG})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 1, // Set the opacity of the background image
            zIndex: -1, // Place the background image behind the content
          },
        }}
      >
        <Grid item xs={12} sm={12} md={10}>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              textAlign: "center",
            }}
          >
            <Typography
              onClick={handleSignout}
              sx={{
                display: "flex",
                alignItems: "right",
                paddingRight: "8px",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Go To Login
            </Typography>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={10}
          component={Paper}
          // elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center", // Center vertically
            alignItems: "center", // Center horizontally
            width: "100%",
            "max-width": "100%",
            backgroundColor: "rgba(255, 255, 255, 0.50) !important",
            padding: "16px",
            borderRadius: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: { xs: "0px 16px", sm: "0px" },
              width: "100%",
              boxShadow: "rgba(255,255,255,0.50) !important",
            }}
          >
            <Logo isTitle={true} isPosition={true} />

            <FeatureTable isNew={true} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default PlanList;
